import { Text, TextProps } from "@chakra-ui/react";
import { format } from "date-fns";

export const VairitasCopyrightText = (props: TextProps) => (
  <Text {...props}>
    © Vairitas {format(new Date(), "yyyy")}. All rights reserved. E&OE. Vairitas
    is a product and trading style of BFD (USA), Inc.
  </Text>
);
